import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c95bb2b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-select-container" }
const _hoisted_2 = {
  key: 0,
  class: "c-select-label"
}
const _hoisted_3 = { class: "c-select-label-txt" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "c-search-input"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "c-input-error"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = {
  key: 1,
  class: "empty-box"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1682302506512",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4873",
  width: "64",
  height: "64"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M85.333333 699.733333a426.666667 93.866667 0 1 0 853.333334 0 426.666667 93.866667 0 1 0-853.333334 0Z",
    fill: "#F2F3F5",
    "p-id": "4874"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M294.459733 409.6l13.806934 77.269333A51.2 51.2 0 0 0 358.664533 529.066667H655.342933a51.2 51.2 0 0 0 50.696534-44.0576L716.654933 409.6H844.8v273.066667a42.666667 42.666667 0 0 1-40.814933 42.624L802.133333 725.333333H221.866667a42.666667 42.666667 0 0 1-42.624-40.814933L179.2 682.666667V409.6h115.259733z",
    fill: "#F9F9F9",
    "p-id": "4875"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M618.666667 614.4h-213.333334a29.866667 29.866667 0 0 0 0 59.733333h213.333334a29.866667 29.866667 0 0 0 0-59.733333z",
    fill: "#FFFFFF",
    "p-id": "4876"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M319.761067 272.384h371.1488L835.729067 409.6H716.654933l-21.060266 91.118933-43.7504 28.2624H362.180267l-47.3856-28.2624L294.459733 409.6H186.752z",
    fill: "#FFFFFF",
    "p-id": "4877"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M687.402667 264.533333a25.6 25.6 0 0 1 17.5616 6.980267l137.156266 129.348267c2.619733 2.474667 3.208533 5.845333 2.295467 8.746666L844.8 409.6v273.066667a42.666667 42.666667 0 0 1-40.814933 42.624L802.133333 725.333333H221.866667a42.666667 42.666667 0 0 1-42.624-40.814933L179.2 682.666667V409.6h0.384a8.388267 8.388267 0 0 1 2.0224-8.4736L306.670933 272.298667A25.6 25.6 0 0 1 325.034667 264.533333zM196.266667 682.666667a25.6 25.6 0 0 0 24.098133 25.557333L221.866667 708.266667h580.266666a25.6 25.6 0 0 0 25.557334-24.098134L827.733333 682.666667l-0.008533-267.067734H722.858667l-10.325334 58.538667A76.8 76.8 0 0 1 636.9024 537.6h-261.802667a76.8 76.8 0 0 1-75.630933-63.4624l-10.325333-58.538667H196.258133L196.266667 682.666667z m491.136-401.066667H325.034667a8.533333 8.533333 0 0 0-6.1184 2.5856l-111.010134 114.346667h81.237334a17.066667 17.066667 0 0 1 16.512 12.765866l0.290133 1.339734 10.325333 58.538666A59.733333 59.733333 0 0 0 375.099733 520.533333h261.802667a59.733333 59.733333 0 0 0 58.820267-49.3568l10.325333-58.538666a17.066667 17.066667 0 0 1 16.810667-14.1056h91.921066l-121.5232-114.602667a8.533333 8.533333 0 0 0-4.778666-2.261333L687.402667 281.6z",
    fill: "#E0E2E8",
    "p-id": "4878"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M618.666667 614.4h-213.333334a29.866667 29.866667 0 0 0 0 59.733333h213.333334a29.866667 29.866667 0 0 0 0-59.733333z m-213.333334 17.066667h213.333334a12.8 12.8 0 0 1 0 25.6h-213.333334a12.8 12.8 0 0 1 0-25.6z",
    fill: "#E0E2E8",
    "p-id": "4879"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

import { computed, onMounted, reactive, onUnmounted, watchEffect } from 'vue';
import { emitter } from '@/utils/eventBus'
// console.log(useSlots().default?.(), 'Select')
//暂时只考虑了必填规则
interface RullProp {
  required?: boolean;
  message: string;
}
// TS 别名
// 定义验证规则数组的数据类型
type RulesProp = RullProp[];
interface OptionProp {
  title: string,
  value: string | number,
}
type OptionsProp = OptionProp[]

interface SelectProps {
  placeholder?: string;
  options?: OptionsProp;
  label?: string;
  value?: string | number;
  inputStyle?: object;
  rules?: RulesProp;
  showSearch?: boolean;
  placement?: 'bottom' | 'top'
}

const __default__ = {
  name: 'CSelect'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    placeholder: {},
    options: {},
    label: {},
    value: {},
    inputStyle: {},
    rules: {},
    showSearch: { type: Boolean, default: false },
    placement: { default: 'bottom' }
  },
  emits: ['update:value', 'change', 'search'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const state = reactive({
  message: '',
  error: false,
  required: false,
  showDropDown: false,
  isSearchInputFocus: false,
  isSearchInputInput: false,
  //选中value
  selectValue: null,
  //搜索文本
  searchValue: ''
})
const selectOptions = computed(() => {
  if (props.options) {
    return props.options
  } else {
    return []
  }
})
const onSelectClick = () => {
  // console.log(document.querySelectorAll('.c-select-dropdown-show'))
  //解决div失去焦点事件无法触发 从而影响下拉选择款无法及时关闭
  let nodeList = document.querySelectorAll('.c-select-dropdown-show')
  if (nodeList && nodeList.length) {
    nodeList.forEach(node => {
      node.classList.remove('c-select-dropdown-show')
    })
  }
  state.showDropDown = !state.showDropDown
}
const onFocus = () => {
  state.isSearchInputFocus = true
  // emit('search', state.searchValue)
}
const onInput = (e) => {
  state.searchValue = e.target.value
  if (state.searchValue) {
    state.isSearchInputInput = true
  } else {
    state.isSearchInputInput = false
  }
  emit('search', state.searchValue)
  // console.log(e.target.value)
}
const onSelectBlur = () => {
  // state.isSearchInputFocus = false
  // state.isSearchInputInput = false;
  // let searchInput = document.querySelector('#searchInput') as HTMLInputElement
  // if (searchInput) {
  //   searchInput.value = ''
  // }
  validateInput()
  // setTimeout(() => {
  //   state.showDropDown = false
  // }, 100)
}
const onOptionClick = (item) => {
  state.isSearchInputFocus = false
  state.isSearchInputInput = false
  state.searchValue = ''
  state.selectValue = item.value
  emit('update:value', item.value)
  emit('change', item.value)
  closeDropDown()
}
const selectValue = computed(() => {
  return selectOptions.value.find(item => item.value == state.selectValue)?.title
})
const validateInput = (): boolean => {
  // 接收从父组件传递过来的验证规则（数组类型）
  if (props.rules) {
    // 调用数组的 every 方法，判断是否符合定义的俩种表单验证规则
    const allPassed = props.rules.every(rule => {
      //若有多种不同的规则 可封装成函数验证所有规则
      // 表单是否通过验证的标志
      let passed = true
      // 先将规则的提示信息赋值，如果表单验证失败，则会直接获得该message信息
      // 因为 every 只要有一个错误 就会返回错误，且其他数组不会再进行判断
      state.message = rule.message
      if (rule.required) {
        if (props.value || props.value == 0) {
          passed = true
        } else {
          passed = false
        }
        // console.log(props.value)
      }
      // console.log(passed)
      return passed
    })
    // 如果表单验证失败，则 allPassed 状态为 false 但是 state 对象中的 error应为 true
    // 所以 allPassed 取反赋值
    state.error = !allPassed
    // validateInput 方法的返回结果
    return allPassed
  }
  // 如果没有 props.rules 的表单规则 则返回 true
  return true
}
const closeDropDown = () => {
  state.showDropDown = false
  state.isSearchInputFocus = false
  state.isSearchInputInput = false
  state.searchValue = ''
}
watchEffect(() => {
  state.selectValue = props.value as any
})
onMounted(() => {
  window.addEventListener('click', closeDropDown)
  if (props.rules) {
    props.rules?.every(rule => {
      if (rule.required) {
        state.required = true
      }
    })
    emitter.emit("formItemCreated", validateInput)
  }
})
onUnmounted(() => {
  window.removeEventListener('click', closeDropDown)
})

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (state.required)
            ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                class: "require-icon",
                icon: "require"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label) + ":", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "c-select-box",
      onClick: _withModifiers(onSelectClick, ["stop"]),
      tabindex: "-1",
      onBlur: _cache[0] || (_cache[0] = ($event: any) => (state.showDropDown = false))
    }, [
      _createElementVNode("div", {
        class: "c-select-control",
        title: selectValue.value,
        style: _normalizeStyle({ ..._ctx.inputStyle })
      }, [
        (_ctx.showSearch)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("input", {
                id: "searchInput",
                style: {"width":"100%"},
                type: "search",
                onFocus: onFocus,
                onInput: onInput,
                value: state.searchValue,
                autocomplete: "off"
              }, null, 40, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        ((typeof state.selectValue !== 'undefined'))
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              style: _normalizeStyle({ color: state.isSearchInputFocus ? '#999999' : '#000000', display: state.isSearchInputInput ? 'none' : 'block' })
            }, _toDisplayString(selectValue.value), 5))
          : (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "c-select-placeholder",
              style: _normalizeStyle({ display: state.isSearchInputInput ? 'none' : 'block' })
            }, _toDisplayString(_ctx.placeholder), 5)),
        (state.isSearchInputFocus)
          ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 3,
              class: "c-search-icon",
              icon: "search"
            }))
          : (_openBlock(), _createBlock(_component_svg_icon, {
              key: 4,
              class: "c-select-icon",
              icon: "down"
            }))
      ], 12, _hoisted_4),
      (state.error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(state.message), 1))
        : _createCommentVNode("", true),
      _createElementVNode("ul", {
        class: _normalizeClass(["c-select-dropdown", { 'c-select-dropdown-show': state.showDropDown, 'top': _ctx.placement == 'top', 'bottom': _ctx.placement == 'bottom' }])
      }, [
        (selectOptions.value && selectOptions.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectOptions.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  title: item.title,
                  class: _normalizeClass(["c-select-option", { 'c-select-active-option': _ctx.value == item.value }]),
                  key: `${item.value}_${index}`,
                  onClick: _withModifiers(($event: any) => (onOptionClick(item)), ["stop"])
                }, _toDisplayString(item.title), 11, _hoisted_9))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
      ], 2)
    ], 32)
  ]))
}
}

})